import { Component } from '@angular/core';
import {AlertController, IonicPage, LoadingController, NavController, NavParams} from 'ionic-angular';
import {UserStateProvider} from "../../providers/user-state/user-state";
import {InitWizardProvider} from "../../providers/init-wizard/init-wizard";
import {ApiInitProvider} from "../../providers/api-init/api-init";
import {AppDashboardPage} from "../app-dashboard/app-dashboard";

/**
 * Generated class for the InitSummaryPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-init-summary',
  templateUrl: 'init-summary.html',
})
export class InitSummaryPage {

  constructor(public navCtrl: NavController, public navParams: NavParams, public state: UserStateProvider, public initWizard: InitWizardProvider, public apiInit: ApiInitProvider, public loadingCtrl: LoadingController, public alertCtrl: AlertController) {
  }

  ionViewWillLoad() {
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad InitSummaryPage');
  }

  goNext() {
    let iloader = this.loadingCtrl.create();
    iloader.present();

    this.apiInit.finishInitialization(this.initWizard).then(success => {

      this.navCtrl.setRoot(AppDashboardPage);
      iloader.dismiss();
    }, err => {
      iloader.dismiss();
      let alert = this.alertCtrl.create({
        title: 'Error',
        message: 'Server error',
        buttons: ['OK']
      });
      alert.present();
    })

  }

}



// WEBPACK FOOTER //
// ./src/pages/init-summary/init-summary.ts